import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Table, Icon, Row, Col, Popconfirm } from 'antd';
import { Animated } from "react-animated-css";


import HeaderContent from '../common/headercontent/HeaderContent';
import AddTranslationModal from './modal/AddTranslationModal';

import TranslationDetails from './form/TranslationDetails';

import './translation.css';

import {
  translationList,
  translationDelete,
  translationListChange
} from '../../modules/translation';

class Translation extends Component {
	constructor(props){
		super(props);
		this.state = {
			addModal: false,
			selectedTranslation: null
		}
	}

	componentDidMount() {
		if (!this.props.translationData) {
			this.getTranslation();		
		}
	}

	toggleAddModal = () => {
		const { addModal } = this.state;
		this.setState({ addModal: !addModal });
	}

	onSelectTranslation(translationId = null) {
		window.scrollTo(0, 0);
		this.setState({ selectedTranslation: null });
		setImmediate(()=> {
			this.setState({ selectedTranslation: translationId });
		});
	}

	getTranslation() {
		this.props.translationList();		
	}


	onDeleteConfirm(translationId) {
		const { selectedTranslation } = this.state;

		this.props.translationDelete(translationId).then( 
			(res) => {
				if (translationId === selectedTranslation) {
					this.setState({ selectedTranslation: null });
				}
				this.getTranslation();
			},
			(err) => {
				this.setState({ loading: false, message: `Can't get through. Please try again later or contact the administrator.` }); 
			}
		);
	}

	onPageChange(page, pageSize) {
		this.translationListChange(page, pageSize);
	}

	onPageSizeChange(current, pageSize) {
		this.translationListChange(current, pageSize);
	}

	render() {
      
		const { addModal, selectedTranslation } = this.state;
		console.log(this.props)

		const columns = [{
			title: 'Translation Id',
			dataIndex: 'translationId',
			key: 'translationId',
			render: (text, data) => {
				return (<a onClick={()=>this.onSelectTranslation(data.key)}>{text}</a>);
			},
		}, {
			title: 'tc',
			dataIndex: 'tc',
			key: 'tc',
		},
    {
			title: 'sc',
			dataIndex: 'sc',
			key: 'sc',
		},
    {
			title: 'en',
			dataIndex: 'en',
			key: 'en',
		},
		{
			title: 'Action',
			key: 'action',
			render: (text, data) => (
			<span>
				<Popconfirm title="Delete this translation?" onConfirm={() => this.onDeleteConfirm(data.key)} okText="Yes" cancelText="No"><a>Delete</a></Popconfirm>
			</span>
		),
		}
	];

		const headerData = {
			button: {
				title: <span><Icon type="file-add" /> Add Translation</span>,
				function: () => this.toggleAddModal()
			}
		};
		
		const headerSTranslationData = (selectedTranslation) ? {
			close: {
				title: <Icon type="close-square" />,
				function: () => this.onSelectTranslation()
			}
		} : "";

		let data = [];
		let sTranslation = [];
		if (this.props.translationData) {
			data = this.props.translationData.results.map(translation => {
				return {
					key: translation._id,
          translationId: translation.translationId,
					tc: translation.tc,
					sc: translation.sc,
          en: translation.en,
				}
			});

			sTranslation = this.props.translationData.results.filter(translation=>translation._id === selectedTranslation);
		}

		return (
			<Animated animationIn="fadeIn">
				<div className="mainContentWrapper" style={{ paddingBottom: (this.props.play) ? '100px' : '20px' }}>
					<Row>
					<Col md={(!selectedTranslation) ? 24 : 12} lg={(!selectedTranslation) ? 24 : 12} xl={(!selectedTranslation) ? 24 : 16} xxl={(!selectedTranslation) ? 24 : 18} className={(selectedTranslation) ? 'tableListHolder':''}>	
							<HeaderContent title="Translation" subtitle="List of Translation" data={headerData} />
							<Card title={<p><span>Translation </span></p>}>
								<Table columns={columns} dataSource={data} pagination={false} />
							</Card>

							<AddTranslationModal 
								show={addModal} 
								toggleAddModal={this.toggleAddModal.bind(this)} 
							/>
						</Col>
						<Col md={(!selectedTranslation) ? 0 : 12} lg={(!selectedTranslation) ? 0 : 12} xl={(!selectedTranslation) ? 0 : 8} xxl={(!selectedTranslation) ? 0 : 6}>
							<div className="mediaDetailsHolder">
								{
									(selectedTranslation) ?
										<div>
											<Animated animationIn="slideInRight" isVisible={(selectedTranslation) ? true : false}>
												<HeaderContent title={sTranslation[0].title} subtitle="Translation Details" data={headerSTranslationData} />
												<Card className="cardDetailsHolder">
													<TranslationDetails data={sTranslation[0]} callback={()=>{this.setState({selectedTranslation: null}); this.props.translationList();}} avatarCallback={true} />
												</Card>
											</Animated>
										</div> : ""
								}
							</div>
						</Col>
					</Row>
				</div>
			</Animated>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	translationData: state.translation.data,
	play: state.translation.play
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		translationList,
		translationDelete,
		translationListChange
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(Translation);